export default {
  // Index
  // resetPassword listed in profile
  // sorryLinkNoLongerValid listed in push-outreach
  // required listed in order-form
  confirmPassword: {
    english: "Confirm Password",
    spanish: "Confirmar Contraseña",
  },
  password: {
    english: "Password",
    spanish: "Contraseña",
  },
  passwordsDoNotMatch: {
    english: "Passwords do not match",
    spanish: "Las contraseñas no coinciden",
  },
  passwordRequirements: {
    english:
      "Password must be at least 8 characters long with 1 number, 1 special character, 1 capital and 1 lowercase letter",
    spanish:
      "La contraseña debe tener al menos 8 caracteres con 1 número, 1 carácter especial, 1 mayúscula y 1 letra minúscula",
  },
  mfaPhoneOptional: {
    english: "Mobile Phone (optional)",
    spanish: "Teléfono Móvil (opcional)",
  },
  mfaPhoneHint: {
    english: "Add your mobile number to receive login codes by text instead of email.",
    spanish: "Agregue su número móvil para recibir códigos de inicio de sesión por mensaje de texto en lugar de correo electrónico.",
  },
  checkingLink: {
    english: "Checking link",
    spanish: "Verificando el enlace",
  },
  resettingPassword: {
    english: "Resetting password",
    spanish: "Restableciendo la contraseña",
  },
};
